import { ServiceResponse } from "../../api/ServiceResponse";
import { RoleDto } from "./RoleDto";

export class RoleResponse extends ServiceResponse {
  private roleList?: RoleDto[];
  private count?: number;

  constructor(init?: Partial<RoleResponse>) {
    super(init);
    Object.assign(this, init);
  }

  // ✅ Getters
  getRoleList(): RoleDto[] | undefined {
    return this.roleList;
  }

  getCount(): number | undefined {
    return this.count;
  }

  // ✅ Setters
  setRoleList(value: RoleDto[] | undefined): void {
    this.roleList = value;
  }

  setCount(value: number | undefined): void {
    this.count = value;
  }
}
